import {takeLatest, put, call} from 'redux-saga/effects';
import apiCall from '../../api';
import {UPDATE_POSTS_ERROR, UPDATE_POSTS_START, UPDATE_POSTS_SUCCESS} from "../../types";

export function* updatePosts({payload}) {
  try {
    const url = `/posts/${payload.formData.id}/`;
    const method = 'PUT';
    const headers = {Authorization: 'Bearer ' + payload.token, 'Content-Type':'multipart/form-data'};

    const data = (object) => Object.keys(object).reduce((formData, key) => {
      formData.append(key, object[key]);
      return formData;
    }, new FormData());

    const results = yield call(apiCall, url, method, data(payload.formData), headers);
    yield put({type: UPDATE_POSTS_SUCCESS, results: results.data});
    yield put(payload.navigate('/app/content-management/manage-post'));
  } catch (error) {
    yield put({type: UPDATE_POSTS_ERROR, error});
    yield put(payload.navigate('/app/content-management/manage-post'))
  }
}

export default function* update_posts() {
    yield takeLatest(UPDATE_POSTS_START, updatePosts);
}